import React from 'react';

import Image from '../../library/image/image';
import { ModalProps } from '../../library/modal/modal';
import Typography from '../../library/typography/typography';
import Modal from '../modal/modal';

import './my-account-modal.scss';

interface MyAccountModalProps extends ModalProps {
  className?: string;
  heading?: React.ReactNode;
  showTreadwellBanner?: boolean;
}

function MyAccountModal(props: MyAccountModalProps) {
  const {
    className,
    heading,
    showTreadwellBanner = false,
    ...restOfProps
  } = props;

  return (
    <Modal
      className={className}
      heading={() => (
        <>
          {showTreadwellBanner && (
            <Image
              alt="treadwell-logo"
              src="/images/treadwell-logo-trademark.svg"
              styleName="treadwell-logo"
            />
          )}
          {heading && (
            <Typography tag="h2" variant="H4" weight="black">
              {heading}
            </Typography>
          )}
        </>
      )}
      styleName={showTreadwellBanner ? 'container' : ''}
      {...restOfProps}
    />
  );
}

export default MyAccountModal;
